import React from "react";
import {useAppStore} from "../../../common/app.store.consumer";
import {ReportChartComponent} from "../types/report.chart.component";
import SelectBox from "devextreme-react/select-box";

const ReportSelectorDropdown: React.FC<ReportChartComponent> = useAppStore()((props: ReportChartComponent) => {
	const store = props.appStore.reportPageStore;

	return (
		<div className="cih-chart-history cih-hide-print">
			<SelectBox
				className="cih-dx-select"
				dataSource={store.answerSheetsSelectOptions}
				value={store.selectedAnswerSheetId}
				displayExpr="answerSheetCreated"
				valueExpr="answerSheetId"
				stylingMode="outlined"
				onValueChanged={(selectedItem) => {
					const selectedOptionId = selectedItem.value;
					store.getUserQuestionnaireAnswerDetails(selectedOptionId);
				}}
			/>
		</div>
	);
});

export default ReportSelectorDropdown;
